/* eslint-disable no-empty-pattern */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable no-mixed-operators */

import { FieldArray, FormikProps } from "formik";
import { Dispatch, useState, SetStateAction } from "react";
import Input from "../../../../../components/Input";
import InputSelect from "../../../../../components/Input-select";
import InputFormik from "../../../../../components/InputFormik";
import useAuthData from "../../../../../hook/useAppData";
import { convertHoursIntoSeconds, convertSecondsToHoursAndMinutes } from "../../../../../libs/dateUtils";
import { refactorVariable } from "../../../lib";
import { ClientsUserId, ProjectsUserId, TimeSheetProps } from "../../../model";
import { getProjectsByClient } from "../../../service";

import ButtonAddGroup from "./components/ButtonAddGroup";
import IconTrashComponent from "./components/IconTrash";

interface FieldArrayComponentProps {
  name: string;
  props: FormikProps<TimeSheetProps>;
  errorStatus: any;
  listClient: ClientsUserId[];
  clientValue: IClient[];
  setClientValue: Dispatch<SetStateAction<IClient[]>>;
}

export interface IClient {
  index: number;
  clientName: string;
  idClient: number;
  project: any[];
  projectId: number;
}

function FieldArrayComponent({ name, props, errorStatus, listClient, clientValue, setClientValue }: FieldArrayComponentProps) {
  const { token } = useAuthData();
  const [error, setError] = useState(true);
  const { arrayPoints } = refactorVariable(props);

  function validationLastField(index: number) {
    if (arrayPoints[index]?.entrance >= arrayPoints[index]?.exit) {
      setError(true);
      errorStatus(true);
      return true;
    } else {
      setError(false);
      return false;
    }
  }

  function validationFirstFieldLastField(index: number) {
    const lastExit = convertHoursIntoSeconds(arrayPoints[index - 1]?.exit);
    const newEntrace = convertHoursIntoSeconds(arrayPoints[index]?.entrance);
    const dateEquals = arrayPoints[index]?.date === arrayPoints[index - 1]?.date;

    if (arrayPoints?.length) {
      if (dateEquals && lastExit && newEntrace < lastExit) {
        errorStatus(true);
        setError(true);
        return true;
      } else if (arrayPoints[index]?.entrance < arrayPoints[index]?.exit || !arrayPoints[index]?.exit) {
        setError(false);
        errorStatus(false);
        return false;
      }
    }
  }

  function totalHoursLine(entrace: string, exit: string) {
    const total = convertHoursIntoSeconds(exit) - convertHoursIntoSeconds(entrace);
    return convertSecondsToHoursAndMinutes(total).toString();
  }

  async function updateValueOfClientId(event, index: number) {
    const client = listClient.find((item) => item.name === event.target?.value);
    if (!client && !event.target.value) {
      const newClient = returnDiffThisIndex(index);
      return setClientValue(newClient);
    }
    const project = await getProjectsByClient(token, client?.id);

    if (!clientValue?.length) return setClientValue([{ clientName: client?.name, idClient: client?.id, index, project, projectId: 0 }]);

    let newClient = returnDiffThisIndex(index);
    let item = [...newClient, { clientName: client?.name, idClient: client?.id, index, project, projectId: 0 }];
    setClientValue(item);
  }

  function returnDiffThisIndex(index: number): IClient[] {
    return clientValue?.map((item) => item?.index !== index && item)?.filter(Boolean);
  }

  function getProjectsByClients(index: number) {
    if (!clientValue?.length) return [{ id: 0, name: "" }];
    const client = clientValue?.find((item) => item?.index == index);
    return client?.project || [{ id: 0, name: "" }];
  }

  return (
    <>
      <datalist id="dataList">
        {listClient?.length ? (
          listClient?.map((item) => {
            return <option key={item.id} value={item.name} />;
          })
        ) : (
          <option></option>
        )}
      </datalist>
      <FieldArray name={name}>
        {({ insert, remove, push }) => (
          <div className="rowContainer">
            {arrayPoints?.length > 0 &&
              arrayPoints?.map((points: any, index: number) => {
                return (
                  <div className="w-full flex ponterContainer">
                    <div className="w-full flex items-center justify-evenly gap-1 sm:flex-wrap ">
                      <InputFormik
                        onChange={(e: any) => {
                          props.handleChange(e);
                        }}
                        value={arrayPoints[index]?.date}
                        name={`points[${index}].date`}
                        label="Data"
                        className="inputDate"
                        type="date"
                        placeholder="Data"
                        required={true}
                      />
                      <InputFormik
                        name={`points[${index}].clientId`}
                        type="search"
                        label="Cliente"
                        className="inputDate"
                        placeholder="Selecionar"
                        value={clientValue?.find((item) => item?.index === index)?.clientName}
                        onChange={(event: any) => {
                          updateValueOfClientId(event, index);
                          props.handleChange({ ...event, target: { value: !event.target.value ? undefined : event.target.value } });
                        }}
                        list="dataList"
                        required={true}
                      />
                      <InputSelect
                        name={`points[${index}].projectId`}
                        className="project-timesheet"
                        key={index}
                        placeholder="Selecionar"
                        label="Projeto"
                        list={getProjectsByClients(index)}
                        value={clientValue?.find((item) => item?.index === index)?.projectId}
                        onChange={(e) => {
                          const newClientValue = clientValue?.map((item) => {
                            if (item?.index === index)
                              return {
                                ...item,
                                projectId: e.target.value,
                              };
                            return item;
                          });
                          setClientValue(newClientValue);
                          props.handleChange(e);
                        }}
                        disabled={!clientValue?.find((item) => item?.index === index)?.idClient}
                      />
                      <InputFormik
                        name={`points[${index}].observation`}
                        className="inputDate"
                        label="Observações"
                        value={points.observation}
                        onChange={(e: any) => {
                          props.handleChange(e);
                        }}
                        type="text"
                        placeholder="Observações"
                      />
                      <Input
                        name={`points[${index}].entrance`}
                        className="input-hour"
                        label="Entrada"
                        placeholder="08:00"
                        value={points.entrance}
                        setValue={props.handleChange}
                        type="time"
                        required={false}
                        errorMessage="Campo inválido!"
                        errorStatus={validationFirstFieldLastField(index)}
                        pattern="[0-9]{2}:[0-9]{2}"
                      />
                      <Input
                        name={`points[${index}].exit`}
                        className="input-hour"
                        label="Saída"
                        placeholder="08:00"
                        value={points.exit}
                        setValue={props.handleChange}
                        type="time"
                        errorMessage="Campo inválido!"
                        errorStatus={validationLastField(index)}
                        pattern="[0-9]{2}:[0-9]{2}"
                      />

                      <div className="flex justify-center items-center h-10 totalHours font-source-sans-pro color-text bold">
                        <span>TOTAL:</span>
                        <span>
                          {arrayPoints[index].exit && !validationLastField(index)
                            ? totalHoursLine(arrayPoints[index].entrance, arrayPoints[index].exit as string)
                            : "00:00:00"}
                        </span>
                        <IconTrashComponent
                          arrayPoints={arrayPoints}
                          index={index}
                          remove={() => {
                            let newClient = clientValue?.map((item) => item?.index !== index && item)?.filter(Boolean);
                            setClientValue(newClient);
                            remove(index);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
            <ButtonAddGroup error={error} listClient={listClient} props={props} push={push} />
          </div>
        )}
      </FieldArray>
    </>
  );
}

export default FieldArrayComponent;
